import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import "rxjs/add/operator/map";
import { tokenNotExpired } from 'angular2-jwt';
import { environment } from '../../environments/environment';


@Injectable()
export class AuthService {
  authToken : any;
  user : any;
  
  public serverUrl = environment.apiserver;

  constructor(private http:Http) { }

  signupUser(user){
    let headers = new Headers();
    headers.append('Content-Type','application/json');
    return this.http.post(this.serverUrl+'/api/user/register', user, {headers: headers})
    .map(res => res.json());
  }

  loginUser(user){
    let headers = new Headers();
    headers.append('Content-Type','application/json');
    return this.http.post(this.serverUrl + '/api/user/authandicate', user, {headers: headers})
    .map(res => res.json());
  }

  storeUserData(language, token, user){
    localStorage.setItem('id_token', token);
    localStorage.setItem('language', language);
    localStorage.setItem('user', JSON.stringify(user));
    this.authToken = token;
    this.user = user;
  }
  logout(){
    console.log("loging out")
    this.authToken = null;
    this.user = null;
    localStorage.setItem('id_token', null);
    localStorage.setItem('user', null);
    localStorage.clear();

  }

  loggedIn() {
    return tokenNotExpired('id_token');
  }

  getProfile(){
    let headers = new Headers();
    this.loadToken();
    headers.append('Content-Type','application/json');
    let luser = this.user
    return this.http.post(this.serverUrl + '/api/user/profile', luser, {headers: headers})
    .map(res => res.json());
  }

  loadToken(){
    const token = localStorage.getItem('id_token');
    const luser = localStorage.getItem('user');
    this.authToken = token;
    this.user = luser;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts